// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__3Osb_","Header":"styles_Header__1rqMl","LoginButton":"styles_LoginButton__Lsoeo"};